var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8C6.43301 8 8 6.43301 8 4.5C8 2.567 6.43301 1 4.5 1C2.567 1 1 2.567 1 4.5C1 6.43301 2.567 8 4.5 8Z",
    stroke: "#3E4159",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05545 4.5C6.05545 2.16667 4.49989 1 4.49989 1C4.49989 1 2.94434 2.16667 2.94434 4.5C2.94434 6.83333 4.49989 8 4.49989 8C4.49989 8 6.05545 6.83333 6.05545 4.5Z",
    stroke: "#3E4159",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5H1",
    stroke: "#3E4159",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.1f77f8b31cd0493ae294b94dc4c7771b.svg";
export { ForwardRef as ReactComponent };